import type { AuthPermissionUser } from '../../services/authPermissions';

// UX mirror of backend/src/utils/marketingPolicy.js. The API is the boundary.
export const MARKETING_HOME_PATH = '/app/customers';
const MARKETING_APP_PATH_PREFIXES = ['/app/customers', '/app/suppliers', '/app/factories'];

export function isMarketing(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'MARKETING';
}

export function isMarketingAppPathAllowed(pathname: string): boolean {
  const path = pathname.split('?')[0].replace(/\/$/, '');
  if (/[%\\\x00-\x20#]/.test(path) || path.includes('//')
    || path.split('/').some((part) => part === '.' || part === '..')) return false;
  if (path === '/app/settings') return true;
  return MARKETING_APP_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}
